import React, { useState } from "react";
import { useCreateFileToolMutation, useDeleteFileToolMutation, useGetFileToolsQuery } from "../../../Store/Apis/toolsApi";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import Skeleton from "../../../Components/Skeleton/Skeleton";

const FileTools = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const getFileToolApi = useGetFileToolsQuery();
  const [createFileTool] = useCreateFileToolMutation()
  const [deleteFileTool] = useDeleteFileToolMutation()
  
  const handleDelete = () => {
    setSelectedImage(null);
    setImagePreview("");
  };
  
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result); // Base64 preview
      };
      reader.readAsDataURL(file);
      setSelectedImage(file);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const handleUpload = () => {
    if (selectedImage) {
      createFileTool({
        image: imagePreview
      }).then((res)=>{
        if(res.data.status === 200) {          
          toast.success(res?.data?.message, { duration: 7000 });
          setImagePreview("");
        }
      })
    } else {
      alert("Please select an image first.");
    }
  };

  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState('');
  const handleDeleteFromApi = () => {
    deleteFileTool(selectedDeleteRecord).then((res)=>{
      setSelectedDeleteRecord(null)
    })
  }

  return (
    <>
      <div className="card">
        <div className="card-body p-5">
          <h4 className="text-center mb-4">
            File Tools
          </h4>
          <div className="row justify-content-center align-items-center mb-5">
            <div className="col-lg-5 col-md-7">
              <input
                type="file"
                className="form-control image-file"
                accept="image/png"
                onChange={handleFileChange}
              />
              <p className="text-xs text-center mb-4 mt-3">
                <span className="text-danger fw-600">Important! </span>
                <span>
                  Upload 1:1 <b>".png"</b> images or icons only &amp; the image
                  name should not contain any spaces.
                </span>
              </p>
              <div className="text-center">
                <button
                  className="btn btn-primary text-white mb-0"
                  onClick={handleUpload}
                  disabled={!selectedImage}
                >
                  Upload Image
                </button>
              </div>

              <div className="row justify-content-center mt-4">
                {imagePreview && (
                  <div className="col-auto position-relative">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="img-thumbnail border-dark"
                      style={{height: "70px"}}
                    />
                    <button
                      className="badge bg-danger btn btn-danger mb-0 px-2 py-1"
                      onClick={handleDelete}
                      title="Delete Image"
                      style={{position: 'absolute', top: '7px', right: '15px', zIndex: '111'}}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>            
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-7">
              <div className="row g-3 align-items-center mb-4">
              {/* getFileToolApi.isLoading */}
              {
                  getFileToolApi.isLoading && (
                    [1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 2, 3, 4, 5].map((elem, i) => {
                        return (
                            <div className="col-auto">
                              <Skeleton type={'rounded'} height='70px' width='70px' backgroundColor="rgb(9 56 85 / 5%)"/>
                            </div>
                        )
                    })
                  )
              }
              {
                getFileToolApi.isSuccess && (getFileToolApi.data.data.length > 0 ? (
                  getFileToolApi.data.data.map((elem)=>{
                    return(
                      <div className="col-auto position-relative" key={elem.id}>
                        <img
                          src={elem.image}
                          alt="Preview"
                          className="img-thumbnail"
                          style={{ height: "70px" }}
                        />
                        <button
                          className="badge bg-danger btn btn-danger mb-0 px-2 py-1"
                          onClick={()=>setSelectedDeleteRecord(elem.id)}
                          title="Delete Image"
                          style={{position: 'absolute', top: '7px', right: '15px', zIndex: '111'}}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    )
                  })
                ) : <p className="text-center my-5 py-5 text-dark col-12">No Data found</p>)
              }
              
            </div>
            </div>
          </div>
        </div>
      </div>

      {/* DELETE MODAL */}
      <Modal  
          show={selectedDeleteRecord} 
          onHide={() => setSelectedDeleteRecord('')} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to delete this image?</h5>
              <p className='text-sm mb-4'>
                This action will permanently delete the Image. Please confirm to proceed.
              </p>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedDeleteRecord(''))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleDeleteFromApi}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>
    </>
  );
};

export default FileTools;
